<script setup>
import { computed } from 'vue'

import { PROGRESS_MODULE_CELL_PLACEMENTS } from '@/utils/custom-dashboard-helper'
import { getPeriodDuration } from '@/utils/element-progress'
import { TARGET_PERIOD_ENTITY_KEYS } from '@/utils/entity-keys'
import { currentUserCanReadObjective } from '@/utils/objectives'

import ProgressModuleGridCell from '@/components/dashboard/custom-dashboard/modules/progress-module/ProgressModuleGridCell'

defineOptions({
  name: 'ProgressModuleGridRow'
})

const props = defineProps({
  element: {
    type: Object,
    required: true
  },

  placement: {
    type: String,
    default: PROGRESS_MODULE_CELL_PLACEMENTS.CUSTOM_DASHBOARD,
    validator: v => Object.values(PROGRESS_MODULE_CELL_PLACEMENTS).includes(v)
  }
})

const elementCells = computed(() => {
  return props.element.progressData.map(item => {
    return {
      ...item,
      duration: getPeriodDuration(item)
    }
  })
})

const hasReadAccess = computed(() => currentUserCanReadObjective(props.element))
</script>

<template>
  <div class="pmgr-Row">
    <ProgressModuleGridCell
      v-for="cellData in elementCells"
      :key="cellData[TARGET_PERIOD_ENTITY_KEYS.START_DATE]"
      :cell-data
      :element
      :has-read-access
      :placement
    />
  </div>
</template>

<style lang="scss" scoped>
.pmgr-Row {
  display: flex;
  height: var(--cdpm-row-height, var(--pv-row-height, auto));
}
</style>
